var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('page-list',{attrs:{"list":_vm.list,"columns":_vm.columns}}),_c('div',{staticClass:"text-right"},[_vm._v(_vm._s(_vm.$t('scope.text_835', [`${_vm.data.amount}${_vm.data.currency === 'CNY' ? _vm.$t('scope.text_468') : _vm.$t('scope.text_469') }`, _vm.data.currency])))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }